import React, { lazy, Suspense } from "react";
import {Table} from "reactstrap";
import { Button } from 'reactstrap';
import Loader from '../../../Loader';
import { getBloodPressureRecord, downloadBloodPressureRecord, deleteBloodPressure } from '../../../services';
import ShareSingleRecord from '../../ShareSingleRecord';
import { showConfirmation, showSuccess } from '../../../../utils/alerts'
import { Link } from "react-router-dom";

const VitalChart = lazy(() => import('./VitalChart'));

class ViewBloodPressure extends React.Component {
  state = {
    bloodPressureRecord: [],
    loading: true,
    modalOpen: false,
    sharedRecordId: null,
    lines: ["systolicBloodPressure", "diastolicBloodPressure"]
  };

  pdfRef = React.createRef();
  chartRef = React.createRef();

  async componentDidMount() {
    
    const response = await getBloodPressureRecord()
    this.setState(prevState => ({
      bloodPressureRecord: response.data.record,
      loading: false
    }))
    
  }

  handleDelete = async (_id) => {
    const result = await showConfirmation("Yes, delete it!")
    if(result.value == true) {
      await deleteBloodPressure({data: {recordId: _id }});
      this.setState(prevState => ({
        bloodPressureRecord: prevState.bloodPressureRecord.filter((record) => record._id !== _id)
      }))
      await showSuccess("success", "Deleted!", "Your file has been deleted");
    }
  };

  generatePdf = async () => {
    const { bloodPressureRecord } = this.state;
    let header = [
      "S.No",
      "Date & Time of test",
      "Lab Name",
      "Blood Pressure(systolic)(mmHg)",
      "Pulse Rate(ppm)",
      "Blood Pressure(Diastolic)(mmHg)"
    ]

    let bodyData = [];
    bloodPressureRecord.forEach((record, index) => {
      bodyData.push([
        index +1,
        record.testDate, 
        record.lab, 
        record.systolicBloodPressure, 
        record.pulseRate, 
        record.diastolicBloodPressure
      ])
    });
    import('../../../../utils/downloadPdf')
      .then(({downloadPdf}) => {
        downloadPdf('BloodPressure', this.chartRef.current, header, bodyData)
      })
    
    // await downloadPdf(this.chartRef.current, header, bodyData)
  }

  handleDownload = async (recordId) => {
    const data = {
      recordId
    }

    const response = await downloadBloodPressureRecord(data);

    import('../../../../utils')
    .then(({downloadFile}) => {
      downloadFile(response.data, "Blood_Pressure");
    })
    
    // downloadFile(response.data, "Blood_Pressure");
    return;
  }

  handleShare = (recordId) => {
    this.setState(prevState => ({
      sharedRecordId: recordId,
      modalOpen: true
    }))
  }

  toggle = () => {
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen
    }))
  }

  render() {

    if(this.state.loading === true) {
      return (
        <Loader />
      )
    }

    const { bloodPressureRecord, lines, modalOpen, sharedRecordId } = this.state

    return (
      <React.Fragment>
        {bloodPressureRecord.length > 0 ? <div ref={this.pdfRef}>
          <Suspense fallback={<Loader />}>
            <div className="container" ref={this.chartRef}>
              <VitalChart data={bloodPressureRecord} lines={lines} />
            </div>
          </Suspense>
          <Table responsive>
            <thead className="tableHeader">
              <tr>
                <th>S.No</th>
                <th>Date & Time of Test</th>
                <th>Lab Name</th>
                <th>Blood Pressure(systolic)(mmHg)</th>
                <th>Pulse Rate(bpm)</th>
                <th>Blood Pressure(Diastolic)(mmHg)</th>
                <th>File Uploaded</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {bloodPressureRecord.map((record, index) => {
                return (
                  <tr key={record._id}>
                    <td scope="row">{index + 1}</td>
                    <td>{record.testDate}</td>
                    <td>{record.lab}</td>
                    <td>{record.systolicBloodPressure}</td>
                    <td>{record.pulseRate}</td>
                    <td>{record.diastolicBloodPressure}</td>
                    <td>{ `${record.files.length} files`}</td>
                    <td className="">
                      <Link
                        className=""
                        to={{
                          pathname: `/edit-vitals/${record._id}`,
                          search: "?disease=3",
                          state: this.props.disease
                        }}>
                        <i className="editRecord fa fa-pencil editable-icons" />
                      </Link>
                      <i className="downloadRecord fa fa-download editable-icons" 
                        onClick={() => this.handleDownload(record._id)}
                      />
                      <i className="shareRecord fa fa-share editable-icons" 
                        onClick={() => this.handleShare(record._id)}
                      />
                      <i
                        className="deleteRecord fa fa-trash editable-icons"
                        onClick={() => this.handleDelete(record._id)}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table> 
        </div> :
        <div>
          <h4>No records found</h4>
        </div>
        }
        <div className="my-4">
          <Link 
          to={{
            pathname: "/personalhealthrecord/pregnancyvitalrecord",
            state: this.props.disease
          }}
          >
            <Button className="mr-2">Add Entry</Button>
          </Link>
          {bloodPressureRecord.length > 0 && <Button onClick={this.generatePdf}>Download Pdf</Button> }
        </div>
        <ShareSingleRecord isOpen={modalOpen} recordId={sharedRecordId} toggle={this.toggle} model="5"/>
      </React.Fragment>
    );
  }
}

export default ViewBloodPressure;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyVitals/PregnancyVitalsView/ViewBloodPressure.js